import { render, staticRenderFns } from "./GoggleAnalytics.vue?vue&type=template&id=56017374"
import script from "./GoggleAnalytics.vue?vue&type=script&lang=js"
export * from "./GoggleAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports